// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenshotsPreview_root__3aUAq"};